import { parseTemplate } from 'url-template';
import { SERVER_API } from 'config';
import { appendImpersonateQuery, appendImpersonationForRowiApi } from 'features/impersonation';
export function findAction(user, name) {
    return user.potentialActions[name] || null;
}
/**
 * Resolve the first available root action from an ordered list of names. Used where
 * Owner and Agent get differently-named actions for the same UI (e.g. `listDLProjects`
 * vs `listAgentDLProjects`). Owner-flavored names come first in callers' lists, so the
 * broader view wins if a user ever exposes both.
 */
export function findFirstAction(user, names) {
    for (const name of names) {
        const action = user.potentialActions[name];
        if (action)
            return { name, action };
    }
    return null;
}
export function findActionIn(source, name) {
    return source?.[name] || null;
}
export function materializeTargetUrl(action, variables, impersonateEmail) {
    const template = action.target?.restHttps?.urlTemplate || '';
    if (!template) {
        return '';
    }
    const substituted = parseTemplate(template).expand(variables);
    // Query param is not advertised by potentialAction; patch URL after template substitution.
    return appendImpersonationForRowiApi(substituted, impersonateEmail);
}
export function toStickyOsiUrl(url, impersonateEmail) {
    if (!url) {
        return url;
    }
    const lower = url.toLowerCase();
    if (!lower.includes('osi')) {
        return url;
    }
    return appendImpersonateQuery(url, impersonateEmail);
}
export async function invokeAction(action, token, options = {}) {
    const { variables = {}, impersonateEmail = '', body } = options;
    const targetUrl = materializeTargetUrl(action, variables, impersonateEmail);
    if (!targetUrl) {
        throw new Error('Missing target URL template');
    }
    const restHttps = action.target?.restHttps;
    const method = (restHttps?.httpMethod || 'GET').toUpperCase();
    const headers = {
        Authorization: `Bearer ${token}`,
        'X-Api-Key': SERVER_API.xApiKey,
    };
    let payload;
    if (body !== undefined) {
        headers['Content-Type'] = restHttps?.contentType || 'application/json; charset=utf-8';
        payload = JSON.stringify(body);
    }
    return fetch(targetUrl, { method, headers, body: payload });
}
